import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Quotes, Star } from "@phosphor-icons/react";
import { useLang } from "@/context/LanguageContext";
import { API } from "@/lib/api";
import axios from "axios";

const colors = ["hsl(351 100% 88%)", "hsl(200 75% 82%)", "hsl(298 55% 85%)"];

export default function Testimonials() {
  const { t } = useLang();
  const staticItems = t("testimonials.items");
  const [reviews, setReviews] = useState([]);

  useEffect(() => {
    axios
      .get(`${API}/reviews`)
      .then((res) => setReviews(res.data || []))
      .catch(() => {});
  }, []);

  // Reseñas reales primero, luego las de ejemplo para completar
  const realItems = reviews.map((r) => ({
    name: r.name,
    text: r.text,
    occasion: r.occasion || t("testimonials.verified"),
    rating: r.rating || 5,
  }));
  const items = [...realItems, ...staticItems].slice(0, Math.max(3, realItems.length));

  return (
    <section className="relative py-24 max-w-7xl mx-auto px-5 sm:px-8" data-testid="testimonials-section">
      <div className="text-center max-w-2xl mx-auto mb-16">
        <p className="font-hand text-3xl text-secondary-foreground mb-2">{t("testimonials.kicker")}</p>
        <h2 className="font-display font-bold text-4xl sm:text-5xl tracking-tight text-foreground">{t("testimonials.title")}</h2>
      </div>
      <div className="grid md:grid-cols-3 gap-6">
        {items.map((item, i) => (
          <motion.div
            key={`${item.name}-${i}`}
            data-testid={`testimonial-card-${i}`}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ type: "spring", stiffness: 130, damping: 18, delay: (i % 3) * 0.1 }}
            whileHover={{ y: -8, rotate: i % 2 ? 1 : -1 }}
            className="rounded-[2rem] bg-white p-8 shadow-glass border border-white"
          >
            <Quotes weight="fill" size={40} style={{ color: colors[i % colors.length] }} />
            <p className="mt-4 text-foreground/75 font-medium leading-relaxed">{item.text}</p>
            <div className="mt-6 flex items-center justify-between">
              <div>
                <div className="font-display font-semibold text-foreground">{item.name}</div>
                <div className="text-xs font-bold text-foreground/40">{item.occasion}</div>
              </div>
              <div className="flex gap-0.5">
                {[...Array(5)].map((_, s) => (
                  <Star key={s} weight={s < (item.rating || 5) ? "fill" : "regular"} size={16} className="text-primary" />
                ))}
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
